<template>
  <div style="width: 100%;">
    <v-container fluid>
      <span class="d-flex flex-row align-baseline mb-3">
        <v-btn class="mr-2" fab @click="()=>this.$router.go(-1)" x-small><v-icon>mdi-chevron-left</v-icon></v-btn>
        <h1>Deregister Tags</h1>
      </span>
      <span v-if="loader">
        <v-progress-circular
          indeterminate
          color="green"
        ></v-progress-circular>
      </span>
      <span v-else>
        <v-card outlined>
          <v-card-text>
            <h2>Tags Entered: {{ tags.length }}</h2>
          </v-card-text>
        </v-card>
        <v-btn class="mt-3" block color="success" v-if="!confirmMode" :disabled="tags.length == 0" @click="confirmA" x-large>DEREGISTER</v-btn>
        <v-btn class="mt-3" block color="warning" v-if="confirmMode" @click="confirm" x-large>CONFIRM DEREGISTRATION</v-btn>
      </span>
    </v-container>
    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";
export default {
  data () {
    return {
      deleteDialog: false,
      deleteConfirmed: true,
      loader: true,
      confirmMode: false,
      snackObj: {
        state: false,
        color: '',
        text: ''
      },

      max25chars: v => v.length <= 25 || 'Input too long!',
      editMode: false,
      data: {device: {}},
      singular: "Device",
      singularLower: "device",
      plural: "Devices",
      pluralLower: "devices",
      isEditable: false,
      employees: [],
      steps: ["Step 1: Enter the tags into the bucket", "Step 2: Select the product", "Step 3: Confirm"],
      instruction: "",
      tags: ["TG100","TG101", "TG102"],
      productSearchTerm: "",
      productSearchResults: [],
      loadingSearchProduct: false,
      noSearchResults: false,
      selectedItem: null
    }
  },
  async mounted(){
    try {
     console.log("RFID Deregistration Process Mounted")
     this.instruction = 0
    } catch (error) {
      console.error(error)
      this.snack(error.msg || error, "error");
    } finally {
      this.loader = false;
    }
  },
  computed: {
    ...mapGetters(["getEndpoint", "getRFIDEndpoint", "isAllowed", "getGlobalValue", 'getStationId'])
  },
  methods: {
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.state = true;
      this.snackObj.color = color;
    },
    nextStep(){
      this.instruction++
    },
    confirmA(){
      this.confirmMode = true
    },
    reset(){
      this.tags = []
      this.confirmMode = false
    },
    async confirm(){
      try {
        this.loader = true
        let res = await axios.post(`${this.getRFIDEndpoint}/api/v1rfid/deregisterTags`, {tagIds: this.tags, stationId: this.getStationId});
        if(res.data.error) throw res.data.error
        this.snack("Tags deregistered", "success")
        this.reset()
      } catch (error) {
        console.error(error)
        this.snack(error, "error")
      } finally{
        this.loader = false
      }
    },
  }
}
</script>
